import { siteContent } from '@content';

type PreloadAsset = {
  href: string;
  as: string;
  type?: string;
  fetchPriority?: 'high' | 'low' | 'auto';
  crossOrigin?: 'anonymous' | 'use-credentials';
};

const preloadAssets: PreloadAsset[] = [...siteContent.preloadAssets];
const siteUrl = siteContent.siteUrl.replace(/\/$/, '');
const canonicalSiteUrl = `${siteUrl}/`;

export const seoConfig = {
  ...siteContent,
  siteUrl,
  preloadAssets,
};

export const organizationStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'ClothingStore',
  '@id': `${canonicalSiteUrl}#organization`,
  name: seoConfig.siteName,
  url: seoConfig.siteUrl,
  logo: `${seoConfig.siteUrl}/assets/primary-logo.png`,
  image: seoConfig.defaultImage,
  telephone: seoConfig.contact.telephone,
  email: seoConfig.contact.email,
  address: {
    '@type': 'PostalAddress',
    streetAddress: seoConfig.address.streetAddress,
    addressLocality: seoConfig.address.addressLocality,
    addressRegion: seoConfig.address.addressRegion,
    postalCode: seoConfig.address.postalCode,
    addressCountry: seoConfig.address.addressCountry,
  },
  sameAs: seoConfig.sameAs,
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      opens: '10:00',
      closes: '21:00',
    },
  ],
  priceRange: '₹₹₹',
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer service',
    telephone: seoConfig.contact.telephone,
    email: seoConfig.contact.email,
    areaServed: 'IN',
    availableLanguage: ['en', 'ta'],
  },
};

export const websiteStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': `${canonicalSiteUrl}#website`,
  name: seoConfig.siteName,
  alternateName: ['Sree Silks', 'ஸ்ரீ சில்க்ஸ்'],
  url: seoConfig.siteUrl,
  image: seoConfig.defaultImage,
  inLanguage: ['en-IN', 'ta-IN'],
  publisher: {
    '@id': `${canonicalSiteUrl}#organization`,
  },
};
